import React from 'react';
import InfoBox from './InfoCard';
import { PaginationListType } from '../../../Types/PaginationParams';
import PaginatedView from '../../Utility/PaginatedView';

interface PaginatedCardProps<T> {
    title: string;
    itemsPerPage?: number;
    listType: PaginationListType;
    renderItem: (item: T, index: number) => React.ReactNode;
    HeaderSlot?: React.ReactNode;
    itemsFunction: (
        page: number,
        itemsPerPage: number,
        optionalParams?: Record<string, string>,
        query?: string | null,
    ) => Promise<{ data: { data: T[]; total: number } }> | any;
}

function PaginatedCard<T>({
    title,
    itemsFunction,
    renderItem,
    listType,
    itemsPerPage = 7,
    HeaderSlot,
}: PaginatedCardProps<T>) {
    return (
        <InfoBox title={title} value="">
            <PaginatedView
                listType={listType}
                itemsFunction={itemsFunction}
                itemsPerPage={itemsPerPage}
                renderItem={renderItem}
            >
                {({ list, filter }) => (
                    <>
                        {HeaderSlot ? HeaderSlot : <></>}
                        {filter}
                        {list}
                    </>
                )}
            </PaginatedView>
        </InfoBox>
    );
}

export default PaginatedCard;
